import type { IEventThemeJsonResponse, IEventThemeJsonResponseV1 } from "@/types/eventVault.interface"

export class ThemeJson {
  public tokens?: {
    "--template-header-background"?: string
    "--template-footer-background"?: string
    "--template-primary-colour"?: string
    "--template-secondary-colour"?: string
    "--template-tertiary-colour"?: string
    "--template-link-text"?: string
    "--template-nav-text"?: string
    "--template-nav-active"?: string
    "--template-primary-button-text"?: string
    "--template-secondary-button-text"?: string
    "--template-primary-card-text"?: string
    "--template-secondary-card-text"?: string
    "--template-border"?: string
    "--template-heading-font"?: string
    "--template-base-font"?: string
  }

  public typography?: {
    headingFontValue?: string
    baseFontValue?: string
  }

  constructor(themeJson: Partial<ThemeJson>) {
    this.tokens = themeJson.tokens
    this.typography = themeJson.typography
  }

  public static fromResponse(response?: IEventThemeJsonResponse) {
    return new ThemeJson({
      tokens: response?.Tokens,
      typography: response?.Typography && {
        headingFontValue: response.Typography.HeadingFontValue ?? "Comfortaa",
        baseFontValue: response.Typography.BaseFontValue ?? "Montserrat",
      },
    })
  }

  public static fromResponseV1(response?: IEventThemeJsonResponseV1) {
    return new ThemeJson({
      tokens: response?.tokens,
      typography: response?.typography,
    })
  }
}
